const getUpdatedFields = (newValues, oldValues) => {
  const updatedFields = Object.keys(newValues).filter((key) => {
    return newValues[key] !== oldValues[key]
  })
  return updatedFields
}

module.exports = { getUpdatedFields }
